import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const selectBadgeDefaultVariants = {}
const selectBadgeCompoundVariants = []

const selectBadgeSlotNames = [
  [
    "root",
    "select-badge__root"
  ],
  [
    "dropdown",
    "select-badge__dropdown"
  ],
  [
    "label",
    "select-badge__label"
  ],
  [
    "input",
    "select-badge__input"
  ],
  [
    "section",
    "select-badge__section"
  ]
]
const selectBadgeSlotFns = /* @__PURE__ */ selectBadgeSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, selectBadgeDefaultVariants, getSlotCompoundVariant(selectBadgeCompoundVariants, slotName))])

const selectBadgeFn = memo((props = {}) => {
  return Object.fromEntries(selectBadgeSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const selectBadgeVariantKeys = []
const getVariantProps = (variants) => ({ ...selectBadgeDefaultVariants, ...compact(variants) })

export const selectBadge = /* @__PURE__ */ Object.assign(selectBadgeFn, {
  __recipe__: false,
  __name__: 'selectBadge',
  raw: (props) => props,
  variantKeys: selectBadgeVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, selectBadgeVariantKeys)
  },
  getVariantProps
})